
















































/* eslint-disable @typescript-eslint/naming-convention */
import { PropType, computed, defineComponent } from '@nuxtjs/composition-api';
import { SfList } from '@storefront-ui/vue';
import { Preparations } from '~/modules/catalog/types';

export default defineComponent({
  name: 'ProductPreparations',
  components: { SfList },
  props: {
    preparations: {
      type: Object as PropType<Preparations>,
      required: true,
    },
  },
  setup(props) {
    const before_test_preparations = computed(() => (props.preparations as Preparations)?.before_test_preparations || []);
    const medication_preparations = computed(() => (props.preparations as Preparations)?.medication_preparations || []);
    const food_and_alcohol_preparations = computed(() => (props.preparations as Preparations)?.food_and_alcohol_preparations || []);
    const hasPreparations = computed(
      () =>
        props.preparations &&
        (before_test_preparations.value?.length > 0 || medication_preparations.value?.length > 0 || food_and_alcohol_preparations.value?.length > 0),
    );

    return {
      before_test_preparations,
      medication_preparations,
      food_and_alcohol_preparations,
      hasPreparations,
    };
  },
});
